import React from "react";
import { Button, Collapse } from "reactstrap";
import { FaRegStar } from "react-icons/fa";

function CollapseReview({
  args,
  onChange,
  onKeyUp,
  isOpen,
  onClick,
  error,
  value,
}) {
  return (
    <Collapse isOpen={isOpen}>
      <div className="p-4">
        <div className="w-100">
          <p className="fs-5 fw-bold">Write a review</p>

          <div className="">
            <label className="mt-3">Rating</label>
            <div className="d-flex review_star mt-2">
              <FaRegStar />
              <FaRegStar />
              <FaRegStar />
              <FaRegStar />
              <FaRegStar />
            </div>
          </div>

          <div className="">
            <label className="mt-3">Reviews(500)</label>
            <textarea
              className="fs-6 w-100 border_input mt-2 px-3 py-1 textarea_review"
              type="text"
              maxLength={500}
              value={value}
              placeholder="Write your comments here"
              onChange={onChange}
              onKeyUp={onKeyUp}
            />
          </div>

          {error.review && <p className="text-start error">{error.review}</p>}

          <Button className="btn_review mt-3" onClick={onClick}>
            Submit Review
          </Button>
        </div>
      </div>
    </Collapse>
  );
}

export default CollapseReview;
